var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"label bold font-14"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('SelectComp',{attrs:{"disabled":_vm.isDisabled,"options":_vm.list || [],"multiple":true,"placeholder":"Selecione as opções"},model:{value:(_vm.field),callback:function ($$v) {_vm.field=$$v},expression:"field"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }